The identifier for the `DraftApplicationQuestionChoice`.
